import React, { useState, useEffect } from "react";
import { Container, Form, Button, Alert, Table } from "react-bootstrap";
import { ApiGet, ApiPost, ApiPut, ApiDel } from "../../../service/ApiService";

const WarehouseManagement = () => {
  const [warehouses, setWarehouses] = useState([]);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState("");
  const [formData, setFormData] = useState({ warehouseName: "", warehouseType: "" });
  const [editingId, setEditingId] = useState(null);

  // Fetch warehouses on component load
  const fetchWarehouses = () => {
    ApiGet(
      "/api/smartbill/warehouses",
      (response) => {
        setError(null);
        setWarehouses(response || []);
      },
      (err) => {
        setError(err.response?.data?.message || "Eroare la preluarea depozitelor.");
        setWarehouses([]);
      }
    );
  };

  useEffect(() => {
    fetchWarehouses();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.warehouseName || !formData.warehouseType) {
      setError("Completati numele si tipul depozitului.");
      return;
    }

    if (editingId) {
      // Update warehouse
      ApiPut(
        `/api/smartbill/warehouses/${editingId}`,
        formData,
        (response) => {
          setSuccess("Depozitul a fost actualizat cu succes.");
          setError(null);
          setFormData({ warehouseName: "", warehouseType: "" });
          setEditingId(null);
          fetchWarehouses();
        },
        (err) => {
          setError(err.response?.data?.message || "Eroare la actualizarea depozitului.");
        }
      );
    } else {
      // Create new warehouse
      ApiPost(
        "/api/smartbill/warehouses",
        formData,
        (response) => {
          setSuccess("Depozitul a fost adăugat cu succes.");
          setError(null);
          setFormData({ warehouseName: "", warehouseType: "" });
          fetchWarehouses();
        },
        (err) => {
          setError(err.response?.data?.message || "Eroare la adăugarea depozitului.");
        }
      );
    }
  };

  const handleEdit = (warehouse) => {
    setEditingId(warehouse.id);
    setFormData({
      warehouseName: warehouse.warehouseName,
      warehouseType: warehouse.warehouseType,
    });
  };

  const handleDelete = (warehouseId) => {
    if (window.confirm("Sigur doriți să ștergeți acest depozit?")) {
      ApiDel(
        `/api/smartbill/warehouses/${warehouseId}`,
        (response) => {
          setSuccess("Depozitul a fost șters cu succes.");
          setError(null);
          fetchWarehouses();
        },
        (err) => {
          setError(err.response?.data?.message || "Eroare la ștergerea depozitului.");
        }
      );
    }
  };

  return (
    <Container className="mt-5">
      <h1>Management Depozite</h1>

      {error && <Alert variant="danger">{error}</Alert>}
      {success && <Alert variant="success">{success}</Alert>}

      <h2>Lista Depozitelor</h2>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>ID</th>
            <th>Nume</th>
            <th>Tip</th>
            <th>Acțiuni</th>
          </tr>
        </thead>
        <tbody>
          {warehouses.length > 0 ? (
            warehouses.map((wh) => (
              <tr key={wh.id}>
                <td>{wh.id}</td>
                <td>{wh.warehouseName}</td>
                <td>{wh.warehouseType}</td>
                <td>
                  <Button variant="info" size="sm" onClick={() => handleEdit(wh)}>
                    Edit
                  </Button>{" "}
                  <Button variant="danger" size="sm" onClick={() => handleDelete(wh.id)}>
                    Șterge
                  </Button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4">Nu există depozite.</td>
            </tr>
          )}
        </tbody>
      </Table>
      
      <h2>Adaugă depozit</h2>

      <Form onSubmit={handleSubmit} className="mb-4">
        <Form.Group className="mb-3" controlId="warehouseName">
          <Form.Label>Nume Depozit</Form.Label>
          <Form.Control
            type="text"
            name="warehouseName"
            value={formData.warehouseName}
            onChange={handleInputChange}
            placeholder="Introduceți numele depozitului"
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="warehouseType">
          <Form.Label>Tip Depozit</Form.Label>
          <Form.Control
            type="text"
            name="warehouseType"
            value={formData.warehouseType}
            onChange={handleInputChange}
            placeholder="Introduceți tipul depozitului"
          />
        </Form.Group>
        <Button variant="primary" type="submit">
          {editingId ? "Actualizează Depozitul" : "Adaugă Depozit"}
        </Button>
      </Form>

    </Container>
  );
};

export default WarehouseManagement;